(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["event-order"] && !Shopify.designMode) return;
  try {
    
function initializeEventQuantities() {
  const form = document.getElementById('EventOrderForm');
  if (!form || form.dataset.quantitiesReady) return;
  const inputs = Array.from(form.querySelectorAll('[data-flavor-quantity]'));
  if (!inputs.length) return;
  form.dataset.quantitiesReady = 'true';
  const error = form.querySelector('#Event-quantity-error');
  const totalInput = form.querySelector('#Event-total');
  const display = form.querySelector('#Event-total-display');
  const fulfillmentChoices = Array.from(form.querySelectorAll('[data-fulfillment-choice]'));
  const fulfillmentPanels = Array.from(form.querySelectorAll('[data-fulfillment-panel]'));
  function updateFulfillment() {
    const selected = fulfillmentChoices.find(choice => choice.checked);
    const method = selected ? selected.dataset.fulfillmentChoice : '';
    fulfillmentPanels.forEach(panel => {
      const active = panel.dataset.fulfillmentPanel === method;
      panel.hidden = !active;
      panel.querySelectorAll('[data-required-for]').forEach(field => {
        field.required = active && field.dataset.requiredFor === method;
        if (!active) field.setCustomValidity('');
      });
    });
  }
  fulfillmentChoices.forEach(choice => choice.addEventListener('change', updateFulfillment));
  updateFulfillment();
  function update() {
    let total = 0;
    inputs.forEach(input => {
      const quantity = input.value === '' ? 0 : input.valueAsNumber;
      const valid = Number.isSafeInteger(quantity) && (quantity === 0 || quantity >= 6);
      input.setCustomValidity(valid ? '' : error.dataset.flavorError);
      if (Number.isFinite(quantity)) total += quantity;
    });
    totalInput.value = String(total);
    display.value = String(total);
    error.hidden = true;
    return total;
  }
  inputs.forEach(input => input.addEventListener('input', update));
  form.addEventListener('submit', event => {
    const total = update();
    if (!form.checkValidity()) {
      event.preventDefault();
      form.reportValidity();
    } else if (total < 24) {
      event.preventDefault();
      error.textContent = error.dataset.minimumError;
      error.hidden = false;
      inputs[0].focus();
    }
  });
  update();
}
initializeEventQuantities();
document.addEventListener('DOMContentLoaded', initializeEventQuantities);
document.addEventListener('shopify:section:load', initializeEventQuantities);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
